import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { LOGIN_AUTH } from './types';
import { notify } from '../services/notification'

//Report List GET API 
export const ReportGenerationAction = (id, state, user, district, page, from_date, to_date, agency_code, user_type) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.REPORTS + id + `?page_size=10&page=${page}` + (state ? "&state_id=" + state : "") + (user ? "&user_id=" + user : "") + (district ? "&district_id=" + district : "") + (from_date ? "&from_date=" + from_date : "") + (to_date ? "&to_date=" + to_date : "") + (agency_code ? "&agency_code=" + agency_code :"") + (user_type ? "&user_type=" + user_type :"");  
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(response => {
    if (response.status === 200) {
      dispatch({ type: types.GET_REPORT, payload: response })
      return response
    } else { return null }
}).catch(error => {
  if (error?.response?.status === 400) {
  notify.error(error?.response?.data?.error);
  } 
  else if (error?.response?.status === 504) {
    notify.error("Server is taking too long to respond. Please try again later.");
  }
  else {
    errorHandler(error)
  }

})
}

export const ReportNameListAction = () => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.REPORT_MASTER
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(response => {
    if (response.status === 200) {
      dispatch({ type: types.GET_REPORT_NAME, payload: response })
      return response
    } else { return null }
  })
  .catch(error => {
    const status = error?.response?.status;

    if (status === 504) {
      notify.error("Server is taking too long to respond. Please try again later.");
    } else {
      errorHandler(error);
    }
  });
}
